import React, { useEffect, useState } from 'react';
import { Spin, Tabs } from 'antd';
import { TableOutlined, ScheduleOutlined, HistoryOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { usePatientData, useReportHistory, useSchedules } from '../../../hooks/usePatientData';
import ReportTab from '../../PatientDetails/ReportTabs';
import ScheduleTab from '../../PatientDetails/ScheduelTab';
import ReportHistoryTab from '../../PatientDetails/REportHistoryTab';
import PatientHeader from '../../PatientDetails/PatientHeader';
import PatientInfoCard from '../../PatientDetails/PatientInfoCard';
import PatientQuestionsCard from '../../PatientDetails/QuestionCard';
import CurrentActivePatient from '../CurrentActivePatient/CurrentActivePatient';
import { getPatientInfo } from '../../../Api/services';

const PatientDetails = () => {
  const location = useLocation();
  const queryClient = useQueryClient();

  const [change, setChange] = useState(false);

  const [patient, setPatient] = useState(null);
  const { answers, loading: answersLoading } = usePatientData(patient?.id);
const [loadingPatient, setLoadingPatient] = useState(true);

useEffect(() => {
  const fetchPatient = async () => {
    try {
      const initialPatient = location.state?.patient;

      if (!initialPatient) {
        setLoadingPatient(false);
        return;
      }

      const res = await getPatientInfo(initialPatient.accountId);
      
      setPatient({
        ...initialPatient,
        ...res, 
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingPatient(false);
    }
  };

  fetchPatient();
}, [location.state]);
  const {
    schedules,
    loading: schedulesLoading,
    createSchedule,
    updateSchedule,
    deleteSchedule,
    refreshSchedules,
  } = useSchedules(patient?.accountId);
  const {
    reportHistory,
    pagination: historyPagination,
    loading: historyLoading,
    loadReportHistory,
  } = useReportHistory(patient?.id);

  const tabItems = [
    {
      key: '1',
      label: <span><TableOutlined className="px-1" />Reports</span>,
      // ReportTab is now read-only — only needs patient
      children: <CurrentActivePatient patient={patient} />,
    },
    {
      key: '2',
      label: <span><ScheduleOutlined className="px-1" />Schedules</span>,
      children: (
        <ScheduleTab
          patient={patient}
          schedules={schedules}
          loading={schedulesLoading}
          onCreate={createSchedule}
          onUpdate={updateSchedule}
          onDelete={deleteSchedule}
          onRefresh={refreshSchedules}
          change={change}
          setChange={setChange}
        />
      ),
    },
    {
      key: '3',
      label: <span><HistoryOutlined className="px-1" />AI Reports History</span>,
      children: (
        <ReportHistoryTab
          patient={patient}
          reportHistory={reportHistory}
          pagination={historyPagination}
          loading={historyLoading}
          onPageChange={loadReportHistory}
        />
      ),
    },
  ];
if (loadingPatient) {
  return     <div className="max-w-7xl mx-auto flex justify-center items-center h-screen">
 <Spin size="large" />
 </div>;
}

if (!patient) {
  return <div>No patient found</div>;
}
  return (
    <div className="max-w-7xl mx-auto">
      <div
        className="p-2 md:p-6 mx-auto bg-white shadow-md rounded-md"
        style={{ boxShadow: '0 6px 14px rgba(41, 141, 159, 0.3)' }}
      >
        <PatientHeader patient={patient} />
        <PatientInfoCard patient={patient} />
        <PatientQuestionsCard answers={answers} loading={answersLoading} />

        <div className="mt-6">
          <Tabs
            defaultActiveKey="1"
            items={tabItems}
            size="large"
            tabBarStyle={{ marginBottom: '24px', borderBottom: '2px solid #f0f0f0' }}
          />
        </div>
      </div>
    </div>
  );
};

export default PatientDetails;